/**
 * Created by emanuele on 23/05/2017.
 */
import React, {Component} from 'react';
import PrintButton from '../PrintButton'
import ReportDipartimentiTabularView from '../report/ReportDipartimentiTabularView'
import PdfButton from '../PdfButton'
import RubricaElencoDipartimenti from '../../pdf/RubricaElencoDipartimenti';

class DipartimentiReportList extends Component {

    constructor(props) {
        super(props);
        this.pdfExport = this.pdfExport.bind(this);
    }

    pdfExport() {
        let ce = new RubricaElencoDipartimenti();
        ce.setTitle("Report Dipartimenti");
        ce.setFileName("report-dipartimenti.pdf");
        ce.setFilterDescription(this.props.filterDescription);
        ce.createPdf(this.props.items);
    }

    render(){
        return (
            <div className="ui segments">
                <div className="ui secondary segment no-print">
                    <div className="ui three column stackable grid">
                        <div className="row">
                            <div className="column">
                                <PrintButton />
                                <PdfButton onClick={(ev) => (this.pdfExport())} />
                            </div>
                            <div className="column">
                            </div>
                            <div className="column">
                            </div>
                        </div>
                    </div>
                </div>
                <div id="printme" className="ui segment">
                    <ReportDipartimentiTabularView {...this.props} />
                </div>
            </div>
        )

    }
}

export default DipartimentiReportList;


/** WEBPACK FOOTER **
 ** ./src/components/rubrica/DipartimentiReportList.js
 **/